// extracted by mini-css-extract-plugin
export var icon = "button-module--icon--78b33";
export var primary = "button-module--primary--0087d";
export var secondary = "button-module--secondary--53813";